"use client"

import InteractiveFeatureSection from "@/components/InteractiveFeatureSection/InteractiveFeatureSection";
import "./DesignTailoredSection.scss";

const DesignTailoredSection = ({ design }) => {

     const { title, description, features = [] } = design;
  return (
      <InteractiveFeatureSection
          title={title}
          description={description}
          features={features}
          sectionClass="design-tailored-section"
        />
  );
};

export default DesignTailoredSection;